// Walerin — scripts propios (vanilla JS, sin librerias externas)

function ovInitReveal() {
  const els = document.querySelectorAll('.ov-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('ov-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ov-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => io.observe(el));
  // Salvaguarda: si por lo que sea el observer no revela algo (fallo puntual del
  // navegador, contenido fuera de flujo, etc.), nunca debe quedar invisible para siempre.
  setTimeout(() => {
    document.querySelectorAll('.ov-reveal:not(.ov-visible)').forEach((el) => el.classList.add('ov-visible'));
  }, 2500);
}

function ovInitCountUp() {
  const els = document.querySelectorAll('[data-ov-count]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        io.unobserve(el);
        const target = parseFloat(el.dataset.ovCount || '0');
        const suffix = el.dataset.ovSuffix || '';
        const dur = 1400;
        const start = performance.now();
        function tick(now) {
          const p = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          const val = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(val) : val.toFixed(1)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    },
    { threshold: 0.5 }
  );
  els.forEach((el) => io.observe(el));
}

function ovInitCarousels() {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-ov-carousel]').forEach((wrap) => {
    const track = wrap.querySelector('[data-ov-track]');
    if (!track) return;

    // Los botones viven en la cabecera de la seccion, FUERA de [data-ov-carousel].
    const scope = wrap.closest('.shopify-section') || wrap.parentElement || document;
    const prev = scope.querySelector('[data-ov-prev]');
    const next = scope.querySelector('[data-ov-next]');

    // scrollBy/scrollTo con behavior:'smooth' NO desplaza este contenedor
    // (comprobado: 0px). Animamos scrollLeft a mano, que si funciona, y
    // apagamos el scroll-snap mientras dura para que no pelee con la animacion.
    let animando = null, garantia = null;
    function animarHasta(destino) {
      const max = track.scrollWidth - track.clientWidth;
      destino = Math.max(0, Math.min(max, destino));
      if (animando) cancelAnimationFrame(animando);
      if (garantia) clearTimeout(garantia);
      const snap = track.style.scrollSnapType;
      const terminar = () => {
        animando = null;
        track.scrollLeft = destino;
        track.style.scrollSnapType = snap;
        sincronizar();
      };
      if (reduce()) { terminar(); return; }
      track.style.scrollSnapType = 'none';
      const ini = track.scrollLeft, delta = destino - ini, t0 = Date.now(), dur = 380;
      const paso = () => {
        const p = Math.min(1, (Date.now() - t0) / dur);
        track.scrollLeft = ini + delta * (1 - Math.pow(1 - p, 3));
        if (p < 1) animando = requestAnimationFrame(paso);
        else terminar();
      };
      animando = requestAnimationFrame(paso);
      // Red de seguridad: si requestAnimationFrame no corre (pestana en segundo
      // plano, navegador que no compone), el desplazamiento igualmente ocurre.
      garantia = setTimeout(terminar, dur + 80);
    }

    // Saltar de tarjeta en tarjeta en vez de un porcentaje fijo
    function mover(dir) {
      const hijos = Array.from(track.children);
      const base = track.getBoundingClientRect().left + track.scrollLeft;
      const pos = hijos.map((c) => Math.round(c.getBoundingClientRect().left + track.scrollLeft - base));
      const actual = track.scrollLeft;
      let destino;
      if (dir > 0) {
        const sig = pos.find((x) => x > actual + 4);
        destino = sig === undefined ? track.scrollWidth : sig;
      } else {
        const antes = pos.filter((x) => x < actual - 4);
        destino = antes.length ? antes[antes.length - 1] : 0;
      }
      animarHasta(destino);
    }

    prev && prev.addEventListener('click', () => mover(-1));
    next && next.addEventListener('click', () => mover(1));

    function sincronizar() {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', sincronizar, { passive: true });
    window.addEventListener('resize', sincronizar);
    sincronizar();

    // Arrastrar con el raton: en escritorio no hay gesto tactil.
    let arrastrando = false, xIni = 0, scrollIni = 0, movido = 0, snapPrevio = '';
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      arrastrando = true; movido = 0;
      xIni = e.clientX; scrollIni = track.scrollLeft;
      snapPrevio = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.style.cursor = 'grabbing';
    });
    track.addEventListener('pointermove', (e) => {
      if (!arrastrando) return;
      const d = e.clientX - xIni;
      movido = Math.abs(d);
      track.scrollLeft = scrollIni - d;
      if (movido > 4) e.preventDefault();
    });
    const soltar = () => {
      if (!arrastrando) return;
      arrastrando = false;
      track.style.scrollSnapType = snapPrevio;
      track.style.cursor = '';
      sincronizar();
    };
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => track.addEventListener(ev, soltar));
    track.addEventListener('click', (e) => { if (movido > 4) { e.preventDefault(); e.stopPropagation(); } }, true);

    track.ovIrA = animarHasta;
  });
}

document.addEventListener('shopify:block:select', (e) => {
  const track = e.target && e.target.closest ? e.target.closest('[data-ov-track]') : null;
  if (!track) return;
  const d = e.target.offsetLeft - track.offsetLeft;
  if (track.ovIrA) track.ovIrA(d); else track.scrollLeft = d;
});

function ovInitProductGallery() {
  document.querySelectorAll('[data-ov-gallery]').forEach((gallery) => {
    const mediaItems = gallery.querySelectorAll('[data-ov-gallery-media]');
    const thumbs = gallery.querySelectorAll('[data-ov-gallery-thumb]');
    if (!mediaItems.length || !thumbs.length) return;

    function pauseMedia(item) {
      const video = item.querySelector('video');
      if (video) video.pause();
      const iframe = item.querySelector('iframe');
      if (iframe && iframe.src) {
        // Forzar recarga del iframe (youtube/vimeo) para detener la reproducción
        iframe.src = iframe.src;
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const targetId = thumb.dataset.ovTarget;
        if (!targetId) return;
        mediaItems.forEach((item) => {
          const isTarget = item.dataset.ovMediaId === targetId;
          if (!isTarget) pauseMedia(item);
          item.classList.toggle('ov-galeria-media-active', isTarget);
        });
        thumbs.forEach((t) => t.classList.remove('ov-thumb-active'));
        thumb.classList.add('ov-thumb-active');
      });
    });
  });
}

function ovInitVariantPicker() {
  document.querySelectorAll('[data-ov-product-form]').forEach((formWrap) => {
    const dataEl = formWrap.querySelector('[data-ov-variants-json]');
    if (!dataEl) return;
    let variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const optionInputs = formWrap.querySelectorAll('[data-ov-option]');
    const idInput = formWrap.querySelector('[data-ov-variant-id]');
    const priceEl = formWrap.querySelector('[data-ov-price]');
    const compareEl = formWrap.querySelector('[data-ov-compare-price]');
    const submitBtn = formWrap.querySelector('[data-ov-submit]');
    const submitLabel = formWrap.querySelector('[data-ov-submit-label]');
    const stringsEl = formWrap.querySelector('[data-ov-strings]');
    let strings = { add: 'Añadir al carrito', soldOut: 'Agotado' };
    if (stringsEl) {
      try { strings = JSON.parse(stringsEl.textContent); } catch (e) {}
    }

    function money(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      });
    }

    function currentSelection() {
      const sel = {};
      optionInputs.forEach((input) => {
        if (input.type === 'radio' && !input.checked) return;
        sel[input.dataset.ovOption] = input.value;
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find((v) => v.options.every((val, i) => sel[i + 1] === val || sel[i] === val));
    }

    function update() {
      if (!optionInputs.length) return;
      const sel = currentSelection();
      const selArr = Object.keys(sel).sort().map((k) => sel[k]);
      const variant = variants.find((v) => v.options.every((val, i) => val === selArr[i]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        if (submitLabel) submitLabel.textContent = variant.available ? strings.add : strings.soldOut;
      }
      formWrap.dispatchEvent(new CustomEvent('ov:variant-change', { detail: { variant } }));
    }

    optionInputs.forEach((input) => input.addEventListener('change', () => {
      update();
      // La galería salta a la primera foto de esa variante (solo al cambiarla, no al cargar).
      const sel = currentSelection();
      const selArr = Object.keys(sel).sort().map((k) => sel[k]);
      const variant = variants.find((v) => v.options.every((val, i) => val === selArr[i]));
      if (variant) document.dispatchEvent(new CustomEvent('ov:ver-variante', { detail: { variant } }));
    }));
    update();
  });
}

function ovInitQuantity() {
  document.querySelectorAll('[data-ov-qty-input]').forEach((input) => {
    const wrap = input.closest('.ov-cantidad-selector') || input.parentElement;
    const decr = wrap.querySelector('[data-ov-qty-decr]');
    const incr = wrap.querySelector('[data-ov-qty-incr]');
    function clamp() {
      let v = parseInt(input.value, 10);
      if (!v || v < 1) v = 1;
      input.value = v;
      return v;
    }
    decr && decr.addEventListener('click', () => { input.value = clamp() - 1; clamp(); });
    incr && incr.addEventListener('click', () => { input.value = clamp() + 1; });
    input.addEventListener('change', clamp);
  });
}

function ovInitPack2() {
  document.querySelectorAll('[data-ov-pack2-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const formWrap = btn.closest('[data-ov-product-form]');
      const idInput = formWrap && formWrap.querySelector('[data-ov-variant-id]');
      const variantId = idInput ? idInput.value : null;
      if (!variantId) return;
      const label = btn.querySelector('.ov-producto-pack2-label') || btn;
      const original = label.textContent;
      btn.disabled = true;
      label.textContent = 'Añadiendo…';
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 2 }),
      })
        .then((r) => r.json().then((d) => ({ ok: r.ok, data: d })))
        .then((res) => {
          if (res.ok) {
            window.location.href = '/cart';
          } else {
            btn.disabled = false;
            label.textContent = original;
            alert((res.data && res.data.message) || 'No se ha podido añadir al carrito.');
          }
        })
        .catch(() => {
          btn.disabled = false;
          label.textContent = original;
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  ovInitReveal();
  ovInitCountUp();
  ovInitCarousels();
  ovInitProductGallery();
  ovInitVariantPicker();
  ovInitQuantity();
  ovInitPack2();
});
